<!-- product section start-->
<section class="section-b-space" style="margin-bottom: 50px;">
    <div class="container">
        <div class="row">
            <div class="col-12 product-related">
                <h3>{{ "shoponline.ProdottiCorrelati" | translate }}</h3>
            </div>
        </div>
        <div class="row search-product">
            <div class="col-xl-2 col-md-4 col-sm-6" *ngFor="let product of products | slice:0:6">
                <div class="product-box">
                   <app-product-box 
	                  [product]="product" 
	                  [currency]="productService?.Currency"
	                  [cartModal]="true">
	                </app-product-box>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- product section end -->